/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { IGraph, LNode, IRoutes, LRoute, ISubGraph } from "../types";
import Tree from "./SymmetricTree";
import Routes from "../Routes";
import { split } from "../tasks/split";

export default class Hola {
	layout(g: IGraph, config): IGraph {
		g.routes = new Routes();

		if (!config.full) {
			const c = getParams(g, config);
			if (!config.preserveLocation) placeAround(c.n, c.size);
			minStress(c.mx, c.n, c.n, c.size);
			fixOverlap(c.n);
			g.setGlobalBox();
			return g;
		}

		const subs = split(g);
		if (subs.length == 1 && subs[0].root !== null) {
			return new Tree().layout(subs[0].g, config);
		}

		g = subs[0].g;
		g.routes = new Routes();
		const c = getParams(g, config);
		if (!config.preserveLocation) placeAround(c.n, c.size);
		minStress(c.mx, c.n, c.n, c.size);
		fixOverlap(c.n);

		if (config.full) {
			planarPlacement(g.routes, c.mx, c.n, c.size);
			g = addSubTrees(g, c.mx, subs.slice(1).sort(byTreeLength), c.size);
		}
		g.setGlobalBox();
		return g;
	}
}

function getParams(g: IGraph, config) {
	const n = g.getNodes();

	let size = 0;
	n.forEach((a, i) => {
		a.isn = i;
		size += a.w + a.h;
	});
	size = Math.round(size / (2 * n.length));

	if (config.itemPadding) size += config.itemPadding;
	else size *= 2;

	const mx = getDistMatrix(g);

	return { n, mx, size };
}
// calculate distance matrix between all nodes
function getDistMatrix(g: IGraph) {
	const m = [];
	const n = g.getNodes();

	for (let i = 0; i < n.length; i++) {
		const line = (m[i] = []);
		line[n[i].isn] = 0;
		getDistLine(n[i], line, i, 1);
	}

	return m;
}

// calculate distance from node n to all other nodes
function getDistLine(n: LNode, line: number[], ii: number, dist: number) {
	let now = [n];
	let next = [];
	while (now.length) {
		for (let i = 0; i < now.length; i++) {
			const from = now[i];
			for (let j = 0; j < from.links.length; j++) {
				const to = from.links[j];
				const ti = to.isn;
				if (ti != ii && !line[ti]) {
					line[ti] = dist;
					next.push(to);
				}
			}
		}

		dist++;
		now = next;
		next = [];
	}
}

/* create initial node placement as a spaced circle */
function placeAround(n: LNode[], size) {
	const step = (Math.PI * 2) / n.length;
	let angle = 0;
	const rad = size * 5;

	n.forEach((a, i) => {
		a.x = Math.round(Math.cos(angle) * rad);
		a.y = Math.round(Math.sin(angle) * rad);
		angle += step;
	});
}

function getStress(mx: number[][], n: LNode[]) {
	const nCount = n.length;
	let x = 0,
		cx,
		cy;
	// for each node, calculate stress
	for (let i = 0; i < nCount; i++) {
		cx = 0;
		cy = 0;
		const from = n[i];
		const line = mx[from.isn];
		for (let j = 0; j < nCount; j++) {
			// skip self
			if (from.isn == j) continue;

			const to = n[j];

			// distance to node
			const dij = line[to.isn];
			const kij = 0.5 / (dij * dij);
			// deltas between nodes
			const dx = from.x - to.x;
			const dy = from.y - to.y;
			const bottom = Math.sqrt(dx ** 2 + dy ** 2);
			if (bottom) {
				cx += kij * (dx - (dij * dx) / bottom);
				cx += kij * (dy - (dij * dy) / bottom);
			}
		}

		// full stress value for the node
		x += Math.sqrt(cx ** 2 + cy ** 2);
	}

	return x;
}

/* detects node with maximum stress and calculate the possible improvment */
function getDelta(mx: number[][], n: LNode[], s: LNode[], size: number) {
	// max stress node index, max stress
	let di = 0,
		dm = 0;
	// x-axis max stress
	let cx,
		cxm = 0;
	// y-axis max stress
	let cy,
		cym = 0;

	const max = n.length;
	const maxS = s.length;
	// for each node, calculate stress
	for (let i = 0; i < maxS; i++) {
		cx = 0;
		cy = 0;
		const from = s[i];
		const line = mx[from.isn];
		for (var j = 0; j < max; j++) {
			// skip self
			if (from.isn == j) continue;

			const to = n[j];

			// distance to node
			const dij = line[to.isn];
			const kij = 0.5 / (dij * dij);
			// deltas between nodes
			const dx = from.x - to.x;
			const dy = from.y - to.y;
			const bottom = Math.sqrt(dx ** 2 + dy ** 2);
			if (bottom) {
				cx += kij * (dx - (size * dij * dx) / bottom);
				cy += kij * (dy - (size * dij * dy) / bottom);
			}
		}

		// full stress value for the node
		const cd = Math.sqrt(cx ** 2 + cy ** 2);
		if (cd > dm) {
			// store max stress node and its stress value
			di = from.isn;
			dm = cd;
			cxm = cx;
			cym = cy;
		}
	}

	// now, we know the max stress node
	// lets check how its position can be optimized
	let k1 = 0,
		k2 = 0,
		k3 = 0;
	const from = n[di];
	const line = mx[di];
	for (var j = 0; j < max; j++) {
		if (di == j) continue;

		const to = n[j];

		const dij = line[to.isn];
		const kij = 0.5 / (dij * dij);

		const dx = from.x - to.x;
		const dy = from.y - to.y;
		const dx2 = dx * dx;
		const dy2 = dy * dy;
		const bottom = Math.sqrt((dx2 + dy2) ** 3);
		if (bottom) {
			k1 += kij * (1 - (size * dij * dy2) / bottom);
			k2 += (kij * size * dij * dy * dx) / bottom;
			k3 += kij * (1 - (size * dij * dx2) / bottom);
		}
	}

	// k1*gx + k2*gy = -cxm
	// k3*gy + k2*gx = -cym
	// =>
	// gx = (-cxm - k2*gy) / k1
	// gy = (-cym - k2*gx) /  k3
	// =>
	// gx = (-cxm - k2*((-cym - k2*gx) /  k3)) / k1
	// gx = -cxm/k1 - (k2*-cym - k2*k2*gx) /  (k3*k1)
	// gx = -cxm/k1 - (k2*-cym)/(k3*k1) - k2*k2*gx/(k3*k1)
	// gx  + k2*k2*gx/(k3*k1) = -cxm/k1 + (k2*cym)/(k3*k1)
	// gx * (1 + k2*k2/(k3*k1)) = -cxm/k1 + (k2*cym)/(k3*k1)
	// gx = (-cxm/k1 + (k2*cym)/(k3*k1)) / (1 + k2*k2/(k3*k1))

	// recommended node shift for x and y axis
	let gx, gy;
	gx = (-cxm / k1 + (k2 * cym) / (k3 * k1)) / (1 + (k2 * k2) / (k3 * k1));
	gy = (-cym - k2 * gx) / k3;

	// node inde, node stress, x shift, y shift
	return [di, dm, gx, gy];
}

function minStress(mx: number[][], n: LNode[], s: LNode[], size: number) {
	let i = 0;
	while (i++ < 100) {
		const [i, m, x, y] = getDelta(mx, n, s, size);
		if (m < 10) break;

		n[i].x += x;
		n[i].y += y;
	}
}

function fixOverlap(n: LNode[]) {
	//const cs = createOverlapConstraints(n);
}

function genEventsList(n: LNode[]) {
	const evs = [];
	for (let i = 0; i < n.length; i++) {
		const el = n[i];
		evs.push([0, i, el.y - el.h / 2]);
		evs.push([1, i, el.y + el.h / 2]);
	}

	evs.sort((a, b) => (a[2] > b[2] ? 1 : a[2] == b[2] ? 0 : -1));

	return evs;
}

function createOverlapConstraints(n: LNode[]) {
	const scan = {};
	const evs = genEventsList(n);
	const left = [];
	const right = [];
	const res = [];

	for (let i = 0; i < evs.length; i++) {
		const el = evs[i];
		const j = el[1];
		const node = n[j];

		if (el[0] == 0) {
			// open
			scan[j] = node;
			const lb = (left[j] = getLeftBounds(scan, node));
			const rb = (right[j] = getRightBounds(scan, node));

			// remove left duplicates
			for (let z = 0; z < lb.length; z++) {
				const el = lb[z];
				const cs = right[el.isn];
				if (cs) {
					right[el.isn] = cs.filter(a => !rb.includes(a));
				}
			}
			// remove right duplicates
			for (let z = 0; z < rb.length; z++) {
				const el = rb[z];
				const cs = left[el.isn];
				if (cs) {
					left[el.isn] = cs.filter(a => !lb.includes(a));
				}
			}
		} else {
			//close
			const lb = left[j];
			const rb = right[j];
			for (let z = 0; z < lb.length; z++) {
				const to = lb[z];
				res.push([to, node]);
				right[to.isn] = right[to.isn].filter(a => a != node);
			}
			for (let z = 0; z < rb.length; z++) {
				const to = rb[z];
				res.push([node, to]);
				right[to.isn] = right[to.isn].filter(a => a != node);
			}

			delete scan[j];
		}
	}

	return res;
}

function getLeftBounds(scan, v: LNode) {
	const left: LNode[] = [];
	const out: LNode[] = [];

	for (const key in scan) {
		const el = scan[key];
		if (el.x < v.x) {
			left.push(el);
		}
	}

	left.sort((a, b) => (a.x > b.x ? -1 : 1));

	for (let i = 0; i < left.length; i++) {
		const el = left[i];
		if (overlapX(el, v) <= 0) {
			out.push(el);
			break;
		}
		if (overlapX(el, v) <= overlapY(el, v)) out.push(el);
	}

	return out;
}

function getRightBounds(scan, v: LNode) {
	const left: LNode[] = [];
	const out: LNode[] = [];

	for (const key in scan) {
		const el = scan[key];
		if (el.x > v.x) {
			left.push(el);
		}
	}

	left.sort((a, b) => (a.x < b.x ? -1 : 1));

	for (let i = 0; i < left.length; i++) {
		const el = left[i];
		if (overlapX(el, v) <= 0) {
			out.push(el);
			break;
		}
		if (overlapX(el, v) <= overlapY(el, v)) out.push(el);
	}

	return out;
}

function overlapX(a: LNode, b: LNode) {
	return (a.w + b.w) / 2 - Math.abs(a.x - b.x);
}
function overlapY(a: LNode, b: LNode) {
	return (a.h + b.h) / 2 - Math.abs(a.y - b.y);
}

const piQuarter = Math.PI / 4;
let aligned = {},
	alignedBase = 0;
type nodeAligner = [LNode, number, number];
type nodeAngles = [LNode, nodeAligner[]];
function planarPlacement(r: IRoutes, mx: number[][], nodes: LNode[], step: number) {
	aligned = {};
	alignedBase = nodes.length;
	nodes.forEach(a => (a.iss = ""));

	const byCount: LNode[] = [].concat(nodes);
	const major = byCount
		.filter(a => a.links.length >= 3)
		.sort((a, b) => (a.links.length > b.links.length ? -1 : a.links.length == b.links.length ? 0 : 1));

	const angles: nodeAngles[] = major.map(a => {
		const angles: nodeAligner[] = [];

		// select best position for each link
		// include two positions for each node
		a.links.forEach(b => {
			const angle = Math.atan2(b.x - a.x, b.y - a.y) + Math.PI;
			const axisA = Math.ceil(angle / (2 * piQuarter)) * 2 * piQuarter;
			const axisB = Math.floor(angle / (2 * piQuarter)) * 2 * piQuarter;

			// related node, axis, angle to axis
			angles.push([b, axisA, Math.abs(angle - axisA)]);
			angles.push([b, axisB, Math.abs(angle - axisB)]);
		});

		// sort by minimal angle
		angles.sort((a, b) => (a[2] > b[2] ? 1 : -1));
		return [a, angles];
	});

	// cores
	angles.forEach(([a, angles]) => {
		const { x, y } = a;
		a.x = Math.round(a.x / step) * step;
		a.y = Math.round(a.y / step) * step;

		for (let i = 0; i < angles.length; i++) {
			//best match
			const t = angles[i];
			const b = t[0];
			// console.log(a.id, "->", b.id, a.x, a.y)
			//link already aligned
			if (r.getRoute(a.id, b.id)) continue;

			const [dx, dy, vx, vy] = detectDir(a, b, t[1], step, x, y);
			if (!r.hasRoute(a.id, vx, vy)) {
				if (r.isAligned(b.id)) {
					//addBend(a, b, r, dx, dy, vx, vy, step);
					// TODO - bend point
				} else {
					b.x += dx;
					b.y += dy;
					r.addRoute(a.id, b.id, vx, vy);
				}
			}
		}
	});

	minStress(
		mx,
		nodes,
		nodes.filter(a => !r.isAligned(a.id)),
		step
	);

	// chains
	major.forEach(a => {
		if (!r.isAligned(a.id)) {
			// if core node was not aligned, fix it position
			a.x = Math.round(a.x / step) * step;
			a.y = Math.round(a.y / step) * step;
		}

		a.links.forEach(b => {
			if (b.links.length == 2) {
				routeLink(a, b, r, step);
			}
		});
	});

	if (major.length === 0) {
		// a single loop
		const a = nodes[0];
		const b = nodes[0].links[0];
		b.x = Math.round(b.x / step) * step;
		b.y = Math.round(b.y / step) * step;
		routeLink(a, b, r, step);
	}
}

function addBend(
	a: LNode,
	b: LNode,
	r: IRoutes,
	dx: number,
	dy: number,
	vx: number,
	vy: number,
	step: number
) {
	//assume that other node can produce the ortogonal link

	// preffered patterns
	// - ortoganal nearest
	// - reverse + ortogonal
	// - back-reverse + ortogonal
	// - back-ortogonal + reverse +ortogonal

	r.addPath(a.id, b.id, vx, vy, []);
	r.addPath(b.id, a.id, -vx, -vy, []);
}

function routeLink(a: LNode, b: LNode, r: IRoutes, step: number) {
	while (true) {
		let next = b.links[0];
		if (next == a) next = b.links[1];

		a = b;
		b = next;
		if (b.links.length > 2) break;

		const angle = Math.atan2(b.x - a.x, b.y - a.y) + Math.PI;
		const axisA = Math.ceil(angle / (2 * piQuarter)) * 2 * piQuarter;
		const axisB = Math.floor(angle / (2 * piQuarter)) * 2 * piQuarter;
		const deltaA = Math.abs(angle - axisA);
		const deltaB = Math.abs(angle - axisB);

		const angles = deltaA < deltaB ? [axisA, axisB] : [axisB, axisA];
		for (let i = 0; i < angles.length; i++) {
			const [dx, dy, vx, vy] = detectDir(a, b, angles[i], step, a.x, a.y);
			if (!r.hasRoute(a.id, vx, vy)) {
				if (r.isAligned(b.id)) {
					//addBend(a, b, r, dx, dy, vx, vy, step);
					return;
				} else {
					b.x += dx;
					b.y += dy;
					r.addRoute(a.id, b.id, vx, vy);
					break;
				}
			}
		}
	}
}

function detectDir(
	a: LNode,
	b: LNode,
	angle: number,
	step: number,
	ox: number,
	oy: number
): [number, number, number, number] {
	// 0 -> north, conter-clockwise
	if (angle <= piQuarter || angle > piQuarter * 7) {
		// north
		return [a.x - b.x, dd(a.y, b.y, oy, step), 0, -1]; // "n"
	} else if (angle <= piQuarter * 3 && angle > piQuarter) {
		// west
		return [dd(a.x, b.x, ox, step), a.y - b.y, -1, 0]; // "w"
	} else if (angle <= piQuarter * 5 && angle > piQuarter * 3) {
		// south
		return [a.x - b.x, dd(a.y, b.y, oy, step), 0, 1]; // "s"
	} else {
		// if (angle <= piQuarter*7 && angle > piQuarter*5){
		// east
		return [dd(a.x, b.x, ox, step), a.y - b.y, 1, 0]; // "e"
	}
}

function dd(a, b, ao, step) {
	// calculate shift to the best grid position
	const dir = Math.sign(ao - b);
	return a - b - (Math.round((ao - b) / step) || dir) * step;
}

const shortPlacementOrder = [
	[0, 1, 0, 0], //bottom
	[1, 0, 0, 0], //right
	[-1, 0, 0, 0], //left
	[0, -1, 0, 0], //top
];

const longPlacementOrder = [
	//bottom-left
	[0, 1, -1, 1], //bottom
	[-1, 0, -1, 1], //left
	//bottom-right
	[0, 1, 1, 1], //bottom
	[1, 0, 1, 1], //right
	//up-right
	[1, 0, 1, -1], //right
	[0, -1, 1, -1], //up
	//bottom-left
	[-1, 0, -1, -1], //left
	[0, -1, -1, -1], //up
];

const fullPlacementOrder = shortPlacementOrder.concat(longPlacementOrder);

function addSubTrees(m: IGraph, mx: number[][], trees: ISubGraph[], step): IGraph {
	const coreSize = m.getNodes().length;
	trees.forEach(({ g, root }) => {
		new Tree().layout(g, { root: g.getNodes()[0].id });
		// find the minimal stress position in main 4 directions
		const match = findSubTreePlace(mx, fullPlacementOrder, m, g, root, step, coreSize);
		if (match) {
			m = match.g;

			// add edge to the linked tree
			const to = g.getRoot().id;
			if (!match.dir[2] && !match.dir[3]) {
				m.routes.addRoute(root, g.getRoot().id, match.dir[0], match.dir[1]);
			}
			m.hash[root].links.push(m.hash[to]);
			m.hash[to].links.push(m.hash[root]);
			return;
		}

		console.log("Can't position sub tree");
	});

	return m;
}

function findSubTreePlace(mx, order, m, g, root, step, coreSize) {
	return order
		.map(dir => {
			// when placing in ortogonal directions, ignore already routed ones
			if (!dir[2] && !dir[3] && m.routes.hasRoute(root, dir[0], dir[1])) return null;

			//set drop orientation
			const gCopy = g.copy();
			const mCopy = m.copy();
			const rNode = gCopy.getRoot();
			const aNode = mCopy.hash[root];

			gCopy.rotate({ x: -dir[0], y: dir[1] });
			const bounds = gCopy.getBox();
			const w = bounds[0][1] - bounds[0][0];
			const h = bounds[1][1] - bounds[1][0];
			const dx = rNode.x - bounds[0][0] - w / 2;
			const dy = rNode.y - bounds[1][0] - h / 2;
			//console.log(aNode.id, dir, rNode.id);
			reserveSpace(mCopy, aNode, w, h, dx, dy, step, dir);
			addSubTree(mCopy, gCopy, aNode, rNode, step, dir);

			const s = getStress(mx, mCopy.getNodes().slice(0, coreSize));
			//console.log(s)
			return { g: mCopy, s, dir };
		})
		.reduce((acc, val) => {
			return !acc || (val && val.s < acc.s) ? val : acc;
		});
}

function reserveSpace(g: IGraph, n: LNode, w, h, dx, dy, step, dir) {
	// shift when placing non-ortogonal
	const nX = n.x + (dir[2] || dir[0]) * step;
	const nY = n.y + (dir[3] || dir[1]) * step;

	// check the node target first
	if (isOccupied(g, nX - step / 2, nX + step / 2, nY - step / 2, nY + step / 2)) {
		// no free space at all, reserve for full graph
		clearSpace(g, nX - (step / 2) * dir[0], nY - (step / 2) * dir[1], w, h, dir, step);
		return;
	}

	const deep = (dir[0] ? w : h) / step - 1;
	if (deep <= 0) return;

	// for direction axis add root_size/2 + block size
	// for inderect axis align root of sub-block and root of block
	// add step/2 to disallow nodes without padding
	let xMin, xMax, yMin, yMax;
	const gap = step * 0.45;
	if (dir[0]) {
		// left, right
		xMin = nX + (step / 2) * dir[0];
		xMax = xMin + w * dir[0]; // do not add step, as first node is already placed
		yMin = nY - h / 2 - gap - dy;
		yMax = yMin + h + gap * 2;
	} else {
		// top, bottom
		xMin = nX - w / 2 - gap - dx;
		xMax = xMin + w + gap * 2;
		yMin = nY + (step / 2) * dir[1];
		yMax = yMin + h * dir[1];
	}

	if (yMin > yMax) [yMin, yMax] = [yMax, yMin];
	if (xMin > xMax) [xMin, xMax] = [xMax, xMin];

	if (isOccupied(g, xMin, xMax, yMin, yMax)) {
		clearSpace(g, nX, nY, w, h, dir, step);
	}
}

function clearSpace(g: IGraph, nX, nY, w, h, dir, step) {
	// let affected = [];
	// if (dir[1]) {
	// 	console.log(Math.sign(dir[1]) ? ">" : "<", nY, (h + step) * dir[1]);
	// } else {
	// 	console.log(Math.sign(dir[0]) ? ">" : "<", nX, (w + step) * dir[0]);
	// }
	g.getNodes().forEach(a => {
		if (dir[1]) {
			if (Math.sign(a.y - nY) == dir[1]) {
				a.y += (h + step / 2) * dir[1];
				// affected.push(a.id);
			}
		} else if (dir[0]) {
			if (Math.sign(a.x - nX) == dir[0]) {
				a.x += (w + step / 2) * dir[0];
				// affected.push(a.id);
			}
		}
	});

	// console.log(affected);
}

function isOccupied(g: IGraph, x1, x2, y1, y2) {
	const nodes = g.getNodes();
	for (let i = 0; i < nodes.length; i++) {
		const a = nodes[i];
		if (a.x >= x1 && a.x <= x2 && a.y >= y1 && a.y <= y2) {
			return true;
		}
	}

	return false;
}

function addSubTree(g: IGraph, s: IGraph, n: LNode, r: LNode, step, dir) {
	const x = n.x + step * (dir[0] || dir[2]) - r.x;
	const y = n.y + step * (dir[1] || dir[3]) - r.y;

	s.translate({ x, y });
	g.importNodes(s.getNodes());
}

function byTreeLength(a: ISubGraph, b: ISubGraph) {
	const ax = a.g.getNodes().length;
	const bx = b.g.getNodes().length;

	return ax > bx ? -1 : ax === bx ? 0 : 1;
}
